import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import branch from "branch-sdk";

const root = ReactDOM.createRoot(document.getElementById("root"));
branch.init("key_live_gClqqR9adNinlzxC7AwmsecfrwmIukGS");

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
